import { AMR_OPTIONS, VISA } from '../constants/common-enums';
import DcfLaunchData from '../lib/dcf/launch-data';
import isEmptyString from './is-empty-string';

/**
 * Extract hashedEmail, amr values from idToken
 * Store the values in dcfLaunchData
 *
 * `AMR` is the `Authentication Method Reference` from EMVCO spec and its value describes
 how the user was verified prior to setting remembered user data.
 * @param {object} idToken
 */
const parseIdToken = idToken => {
  if (!isEmptyString(idToken)) {
    const userInfo = {};
    const hashedEmail = JSON.parse(atob(idToken.split('.')[1])).email;
    const amrCookie = JSON.parse(atob(idToken.split('.')[1])).amr;
    const otpProvider = DcfLaunchData.customProps.transfer?.otpProvider ?? '';

    /*
    * VCO-14507 need to only set flag when MA SSI, not MA OTP login.
    * For MA SSI user, otpProvider is defaulted to VISA since no otp was sent.
    * in Visa use cases, this fn is not called
    */
    if (Array.isArray(amrCookie) && AMR_OPTIONS.indexOf(amrCookie[0]) > 0 && otpProvider === VISA) {
      userInfo.isNonVisaRecognizedUser = true;
    }

    if (!isEmptyString(hashedEmail)) {
      userInfo.emailHash = hashedEmail;
    }
    //set userInfo state with recognized values
    DcfLaunchData.setUserInfo(userInfo);
  }
};

export default parseIdToken;
